import React, { useEffect } from 'react';
import { InputNumber } from 'primereact/inputnumber';
import { dictionary } from '../../../dictionary';

const InvoiceCosts = ({
  conversion,
  espCostNet,
  setEspCostNet,
  espCostGross,
  setEspCostGross,
  espCostNetEUR,
  setEspCostNetEUR,
  espCostGrossEUR,
  setEspCostGrossEUR,
  espCostPrcEUR,
  espCostTotal,
  setEspCostTotal,
  netPaid1Invoice,
  netPaid2Invoice,
}) => {
  useEffect(() => {
    const net = parseFloat(espCostNet) || 0;
    const conv = parseFloat(conversion) || 0;

    if (conv === 0) return;

    const calculatedGrossPln = Number((net * 1.23).toFixed(2));
    const calculatedNetEur = Number((net / conv).toFixed(2));
    const calculatedGrossEur = Number((calculatedNetEur * 1.23).toFixed(2));
    const calculatedTotalCostsEur = Number((calculatedNetEur + parseFloat(espCostPrcEUR || 0)).toFixed(2));

    if (espCostGross !== calculatedGrossPln) setEspCostGross(calculatedGrossPln);
    if (espCostNetEUR !== calculatedNetEur) setEspCostNetEUR(calculatedNetEur);
    if (espCostGrossEUR !== calculatedGrossEur) setEspCostGrossEUR(calculatedGrossEur);
    if (espCostTotal !== calculatedTotalCostsEur) setEspCostTotal(calculatedTotalCostsEur);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    espCostNet,
    conversion,
    espCostPrcEUR, 
    setEspCostGross,
    setEspCostNetEUR,
    setEspCostGrossEUR,
    setEspCostTotal,
  ]);

  return (
    <>
      <div className="field-row">
        <div className="col" style={{ marginRight: '0.5rem' }}>
          <label>{dictionary.esp_dialog_invoice_cost_net}</label>
          <InputNumber
            style={{ width: '100%' }}
            mode="currency"
            currency="PLN"
            value={espCostNet}
            onValueChange={(e) => setEspCostNet(e.value ?? 0)}
          />
        </div>
        <div className="col">
          <label>{dictionary.esp_dialog_invoice_cost_gross}</label>
          <InputNumber style={{ width: '100%' }} mode="currency" currency="PLN" readOnly value={espCostGross} />
        </div>
      </div>
      <div className="field-row">
        <div className="col" style={{ marginRight: '0.5rem' }}>
          <label>{dictionary.esp_dialog_invoice_cost_net_eur}</label>
          <InputNumber style={{ width: '100%' }} mode="currency" currency="EUR" readOnly value={espCostNetEUR} />
        </div>
        <div className="col">
          <label>{dictionary.esp_dialog_invoice_cost_gross_eur}</label>
          <InputNumber style={{ width: '100%' }} mode="currency" currency="EUR" readOnly value={espCostGrossEUR} />
        </div>
      </div>
      <div className="field-row">
        <div className="col" style={{ marginRight: '0.5rem' }}>
          <label>{dictionary.esp_dialog_invoice_cost_prc_eur}</label>
          <InputNumber style={{ width: '100%' }} mode="currency" currency="EUR" value={espCostPrcEUR} />
        </div>
        <div className="col">
          <label>{dictionary.esp_dialog_invoice_cost_total}</label>
          <InputNumber style={{ width: '100%' }} mode="currency" currency="EUR" readOnly value={espCostTotal} />
        </div>
      </div>
      <div className="field-row">
        <div className="col">
          <label>{dictionary.esp_dialog_balance_to_pay}</label>
          <InputNumber
            style={{ width: '100%' }}
            mode="currency"
            currency="PLN"
            value={(espCostNet || 0) - (netPaid1Invoice || 0) - ( netPaid2Invoice|| 0)}
            readOnly
          />
        </div>
      </div>
    </>
  );
};

export default InvoiceCosts;
